<template>
    <div class="space-y-4">
        <section class="acc-glass w-full rounded-2xl border border-white/10 p-5">
            <div class="text-lg font-extrabold tracking-tight">Налаштування · Акаунт і дані</div>
            <div class="mt-1 text-sm text-slate-600 dark:text-white/65">Керування даними облікового запису.</div>

            <div class="mt-4 rounded-xl border border-white/15 bg-white/40 p-4 dark:bg-white/5">
                <div class="font-bold text-slate-900 dark:text-white">Архів даних читача</div>
                <div class="mt-1 text-sm text-slate-600 dark:text-white/65">
                    Завантажте свою Бібліотеку, історію читання та власні рецензії, відгуки й цитати.
                </div>
                <a class="acc-btn mt-3" href="/api/account/reader-export">
                    <i class="fas fa-file-archive" aria-hidden="true"></i>
                    <span>Експортувати дані читача</span>
                </a>
            </div>

            <div class="mt-4 rounded-xl border border-red-400/35 bg-red-500/10 p-4">
                <div class="font-bold text-red-700 dark:text-red-300">Небезпечна зона</div>
                <template v-if="scheduledFor">
                    <div class="mt-1 text-sm text-red-700/90 dark:text-red-200/90">
                        Видалення акаунта заплановано на {{ deadlineLabel }}. Поточний сеанс залишається активним; інші сеанси закрито.
                    </div>
                    <button v-if="canCancel" class="acc-btn mt-3 !border-red-500/45 !text-red-700 dark:!text-red-200" type="button" :disabled="busy" @click="$emit('cancel-deletion')">
                        Скасувати видалення
                    </button>
                    <div v-else class="mt-2 text-sm text-red-700 dark:text-red-200">Термін скасування минув. Очікується остаточне видалення.</div>
                </template>
                <template v-else>
                    <div class="mt-1 text-sm text-red-700/90 dark:text-red-200/90">Видалення можна скасувати протягом 30 днів.</div>
                    <button
                        class="acc-btn mt-3 !border-red-500/45 !text-red-700 dark:!text-red-200"
                        type="button"
                        :disabled="busy"
                        @click="$emit('delete-account')"
                    >
                        <i class="fas fa-trash-alt" aria-hidden="true"></i>
                        <span>Запланувати видалення облікового запису</span>
                    </button>
                </template>
            </div>
        </section>
    </div>
</template>

<script lang="js">
export default {
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
        requestedAt: { type: String, default: null },
        scheduledFor: { type: String, default: null },
        canCancel: { type: Boolean, default: false },
    },
    computed: {
        deadlineLabel() {
            return this.scheduledFor ? new Date(this.scheduledFor).toLocaleString('uk-UA', { dateStyle: 'long', timeStyle: 'short' }) : '';
        },
    },
};
</script>
